"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var select_field_1 = require("../../../../../../../components/form/select-field");
var react_2 = require("react");
var react_redux_1 = require("react-redux");
var letsachieve_1 = require("../../../../../../../api/letsachieve");
var objective_node_1 = __importDefault(require("../objective_node"));
var challenge_1 = require("../../../../../../../reducers/slices/challenge/challenge");
var challengeEditorContext_1 = require("../../../../../../../contexts/challengeEditorContext");
var RESETTABLE_LEADERBOARDS = ["totalOrderValue"];
var LeaderboardObjectiveObjectiveNode = function (props) {
    var _a;
    var isReadOnly = (0, challengeEditorContext_1.useChallengeReadOnly)();
    var data = props.data;
    var dispatch = (0, react_redux_1.useDispatch)();
    // every statistic dropdown queries with the same argument, so they all read one cache entry
    var statisticList = (0, letsachieve_1.useGetStatisticsQuery)({ page: 1, size: 100 }).data;
    var statistics = (_a = statisticList === null || statisticList === void 0 ? void 0 : statisticList.items) !== null && _a !== void 0 ? _a : [];
    var setConfigData = function (config) {
        dispatch((0, challenge_1.setNode)(__assign(__assign({}, props), { data: __assign(__assign({}, data), { config: config }) })));
    };
    var statisticOptions = statistics
        .filter(function (statistic) { return RESETTABLE_LEADERBOARDS.includes(statistic.name); })
        .map(function (statistic) { return ({ label: statistic.name, value: statistic.name }); });
    var configurationComponent = function () {
        var _a, _b, _c, _d, _e;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-2", children: [(0, jsx_runtime_1.jsxs)(react_1.TextField, { isReadOnly: isReadOnly, value: data.config.title, onChange: function (value) { return setConfigData(__assign(__assign({}, data.config), { title: value })); }, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Title" }), (0, jsx_runtime_1.jsx)(react_1.Input, { maxLength: 120 })] }), (0, jsx_runtime_1.jsx)(select_field_1.SelectField, { isDisabled: isReadOnly, label: "Statistic", items: statisticOptions, value: (_b = (_a = data === null || data === void 0 ? void 0 : data.config) === null || _a === void 0 ? void 0 : _a.trigger) === null || _b === void 0 ? void 0 : _b.trigger_target, onChange: function (value) {
                        var _a;
                        setConfigData(__assign(__assign({}, data.config), { trigger: __assign(__assign({}, (_a = data === null || data === void 0 ? void 0 : data.config) === null || _a === void 0 ? void 0 : _a.trigger), { trigger_target: value }) }));
                    } }), (0, jsx_runtime_1.jsxs)(react_1.TextField, { isReadOnly: isReadOnly, value: String((_e = (_d = (_c = data.config) === null || _c === void 0 ? void 0 : _c.trigger) === null || _d === void 0 ? void 0 : _d.trigger_quantity) !== null && _e !== void 0 ? _e : ""), onChange: function (value) {
                        var _a;
                        return setConfigData(__assign(__assign({}, data.config), { trigger: __assign(__assign({}, (_a = data === null || data === void 0 ? void 0 : data.config) === null || _a === void 0 ? void 0 : _a.trigger), { trigger_quantity: Math.abs(parseInt(value)) || 1 }) }));
                    }, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Placements" }), (0, jsx_runtime_1.jsx)(react_1.Input, { type: "number", max: 100, min: 1 })] })] }));
    };
    return (0, jsx_runtime_1.jsx)(objective_node_1.default, __assign({ data: data }, props, { configurationComponent: configurationComponent }));
};
exports.default = (0, react_2.memo)(LeaderboardObjectiveObjectiveNode);
